import { defineMessage } from 'services/localization';

export const messages = {
    monthJanuary: defineMessage('january'),
    monthFebruary: defineMessage('february'),
    monthMarch: defineMessage('march'),
    monthApril: defineMessage('april'),
    monthMay: defineMessage('may'),
    monthJune: defineMessage('june'),
    monthJuly: defineMessage('july'),
    monthAugust: defineMessage('august'),
    monthSeptember: defineMessage('september'),
    monthOctober: defineMessage('october'),
    monthNovember: defineMessage('november'),
    monthDecember: defineMessage('december'),
    placeholder: defineMessage('month'),
};
